import React from "react";
import { connect } from "react-redux";
import { withPage } from "../PageContainer";
import ActionCreator from "../ActionCreator";
import Selectors from "../Selectors";
import * as Ant from "antd";
import { SearchOutlined } from "@ant-design/icons";
import * as Catalog from "../Contexts/CatalogContext";
import styled from "styled-components";
import categoryTreeRoot from "../productCategories";
import CategoryMenuItem from "../Components/CategoryMenuItem";
import CategoryBreadcrumb from "../Components/CategoryBreadcrumb";
import ProductItem from "../Components/ProductItem";
import allHashtags from "../productHashtags";
import ProductHashtags from "../Components/ProductHashtags";
import PromoZones from "../Components/PromoZones";
import * as Theme from "../Theme";
import Constants from "../constants";
import * as Widget from "../Components/Widget";
import * as Icon from "../Components/Icon";

const queryString = require("query-string");
const slugify = require("uslug");

function getCategoryFromLocation(location) {
  function findCat(catName, node) {
    if (node.name === catName) {
      return node;
    }

    for (let child of node.children) {
      const hit = findCat(catName, child);
      if (hit) {
        return hit;
      }
    }

    return null;
  }

  try {
    const catName = queryString.parse(location.search).name;

    if (!catName) {
      return null;
    }

    return findCat(catName, categoryTreeRoot);
  } catch (ex) {
    return null;
  }
}

class ProductListPage extends React.Component {
  constructor(props) {
    super(props);
    const selectedCat = getCategoryFromLocation(props.location);
    this.state = {
      showDrawer: false,
      category: selectedCat || categoryTreeRoot,
      sort: "+created",
      loading: true,
      search: "",
      hashtag: "",
      products: [],
      promoZones: [],
    };
  }

  componentDidMount() {
    this._fetchProducts();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevSelectedCat = getCategoryFromLocation(prevProps.location);
    const selectedCat = getCategoryFromLocation(this.props.location);

    if (selectedCat && selectedCat !== prevSelectedCat) {
      this.setState({ category: selectedCat });
      return;
    }

    if (
      prevState.category !== this.state.category ||
      prevState.sort !== this.state.sort
    ) {
      this._fetchProducts();
    }
  }

  render() {
    const { navActions, location } = this.props;
    const {
      showDrawer,
      category,
      sort,
      search,
      products,
      loading,
      hashtag,
      promoZones,
    } = this.state;

    return (
      <Wrapper>
        <Content>
          <Ant.Row>
            <Ant.Col
              xs={0}
              sm={0}
              md={0}
              lg={5}
              style={{
                backgroundColor: "white",
                minHeight: "calc(100vh - 60px)",
                padding: "30px 10px",
              }}
            >
              <Ant.Input
                value={search}
                onChange={e => this.setState({ search: e.target.value })}
                suffix={
                  <div onClick={this._fetchProducts}>
                    <SearchOutlined />
                  </div>
                }
                placeholder="搜尋課程內容或講師"
                onSubmit={this._fetchProducts}
              />
              <Title>全部商品</Title>
              <CategoryMenuItem
                node={categoryTreeRoot}
                goToCategory={this._goToCategory}
              />
            </Ant.Col>

            <Ant.Col
              xs={24}
              sm={24}
              md={24}
              lg={19}
              style={{ padding: "30px 20px" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {hashtag && (
                  <p
                    style={{
                      fontSize: 20,
                      color: Theme.colors.main,
                      margin: 0,
                      padding: 0,
                    }}
                  >{`#${hashtag}`}</p>
                )}

                <div style={{ flex: 1 }} />

                {/* <Ant.Select
                  value={sort}
                  style={{
                    width: 160,
                    fontSize: 12,
                    borderColor: Theme.colors.main,
                  }}
                  onChange={sort => this.setState({ sort })}
                >
                  <Ant.Select.Option value="+created" style={{ fontSize: 12 }}>
                    依日期排列(由舊到新)
                  </Ant.Select.Option>
                  <Ant.Select.Option value="-created" style={{ fontSize: 12 }}>
                    依日期排列(由新到舊)
                  </Ant.Select.Option>
                  <Ant.Select.Option value="+price" style={{ fontSize: 12 }}>
                    依價位排列(由低到高)
                  </Ant.Select.Option>
                  <Ant.Select.Option value="-price" style={{ fontSize: 12 }}>
                    依價位排列(由高到低)
                  </Ant.Select.Option>
                </Ant.Select> */}
              </div>

              <CategoryBreadcrumb
                key={category.name}
                node={category}
                goToCategory={this._goToCategory}
                extraStyle={{ marginBottom: 20, marginTop: 10 }}
              />

              {loading && (
                <Ant.Spin style={{ display: "block", margin: "0 auto" }} />
              )}

              {!loading && (
                <Grid>
                  {products.map((p, idx) => {
                    return (
                      <ProductItem
                        key={idx}
                        product={p}
                        onClick={() => {
                          navActions.push(`/product?id=${p.id}`);
                        }}
                        extraCss={""}
                      />
                    );
                  })}

                  {/* compensate blank item for ui: justfy-content: space-between */}
                  {[0, 1, 2].map(e => (
                    <ProductItem key={e} product={null} extraCss={""} />
                  ))}
                </Grid>
              )}
            </Ant.Col>
          </Ant.Row>
        </Content>

        <Widget.ToggleDrawer
          onClick={() => this.setState({ showDrawer: true })}
        >
          <Icon.ListAlt size={24} color="white" />

          {/* <Ant.Button onClick={() => this.setState({ showDrawer: true })}>
            分類
          </Ant.Button> */}
        </Widget.ToggleDrawer>

        <Ant.Drawer
          title="課程分類"
          placement="left"
          closable={false}
          onClose={() => this.setState({ showDrawer: false })}
          visible={showDrawer}
        >
          {/* <Ant.Input
            value={search}
            onChange={e => this.setState({ search: e.target.value })}
            prefix={<SearchOutlined />}
          /> */}

          <CategoryMenuItem
            node={categoryTreeRoot}
            goToCategory={this._goToCategory}
          />
        </Ant.Drawer>
      </Wrapper>
    );
  }

  _goToCategory = c => {
    const { navActions } = this.props;
    this.setState({ showDrawer: false, category: c });
  };

  _fetchProducts = async () => {
    this.setState({ loading: true });

    try {
      const { category, sort, search } = this.state;
      let params = {
        category,
        sort,
        search,
      };

      const products = await Catalog.Actions.fetchProducts(params);

      this.setState({ products });
    } catch (ex) {
      //bypass
    }

    this.setState({ loading: false });
  };
}

const Wrapper = styled.div`
  background-color: white;
`;

const Title = styled.p`
  color: ${Theme.colors.main};
  margin-top: 10px;
  font-size: 18px;
`;

const Content = styled.div`
  max-width: 1024px;
  margin: 0 auto;
`;

const PromoZoneTitle = styled.p`
  color: ${Theme.colors.main};
  padding: 5px;
  font-size: 20px;
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: white;
`;

export default withPage(
  connect(
    (state, ownProps) => ({
      profile: Selectors.getLoginUser(state),
    }),
    ActionCreator
  )(ProductListPage)
);
